import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../../../services/library-api';

import { defaultErrorMessage } from '../../../../../constants/errorMessages';

import ConfirmDeletionModalPattern from '../../../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const DeletePlaybookView = ({ id, name, setViews, isDefault, onDeleteSuccess, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            await client.delete(`${API.ROUTES.library.playbookView}${id}/`);

            setViews((views) => views.filter((view) => view.id !== id));

            onDeleteSuccess && (await onDeleteSuccess({ id, isDefault }));

            onClose();
        } catch (e) {
            setIsLoading(false);
            setErrorAlert({ message: defaultErrorMessage, statusCode: e.response?.status });
        }
    };

    return (
        <ConfirmDeletionModalPattern
            title="Delete Playbook View?"
            handleDelete={handleDelete}
            onClose={onClose}
            isLoading={isLoading}
            confirmationTextStart="Are you sure you want to delete"
            confirmationTextEnd="It will no longer be accessible on the client side."
            entityName={`${name}?`}
            variant="secondary"
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            buttonsSize="md"
        />
    );
};

export default DeletePlaybookView;
